module.exports = __webpack_public_path__ + "media/images/emblems/Dagmersellen_LU-39ffd4c1b99b18264eb318f2ead3a478.png";